import { render, staticRenderFns } from "./SupplierSelectWrapper.vue?vue&type=template&id=79ec1caa"
import script from "./SupplierSelectWrapper.vue?vue&type=script&lang=js"
export * from "./SupplierSelectWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports